import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { calculators } from 'data/CalculatorSectionData';
import styles from './CalculatorForm.module.scss';
import { calculatorForms } from '../../utils/calculatorForms';
import { useTranslation } from 'react-i18next';

const CalculatorForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [result, setResult] = useState('0-0 tco2');

  if (!id) {
    return <div>{t('Invalid calculator ID')}</div>;
  }

  const FormComponent = calculatorForms[id];
  if (!FormComponent) {
    return <div>{t('Form not found for this calculator')}</div>;
  }

  const calculator = calculators.find((calc) => calc.id === id);

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setResult('10-20 tco2');
  };

  return (
    <div className={styles.calculatorFormContainer}>
      <div className={styles.backButton} onClick={() => navigate(-1)}>
        <span>←</span> {t('Back')}
      </div>

      <h6 className={styles.calculatorTitle}>
        {t('Calculators')} → {calculator ? t(calculator.titleKey) : t('Unknown')}
      </h6>

      <div className={styles.formAndResultWrapper}>
        <div className={styles.formSection}>
          <form onSubmit={handleSubmit}>
            <FormComponent />
            <button type='submit' className={styles.calculateButton}>
              {t('Calculate')}
            </button>
          </form>
        </div>

        <div className={styles.resultSection}>
          <div className={styles.resultCircle}>
            <p className={styles.resultValue}>{result}</p>
          </div>
          <h2 className={styles.resultTitle}>{t('calculatorView.viewLabel')}</h2>
        </div>
      </div>
    </div>
  );
};

export default CalculatorForm;
